import { Box, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  mandatoryCount: number;
  voluntaryActiveCount: number;
  voluntaryTotalCount: number;
}

export const ExclusionGroundsSummary = ({ mandatoryCount, voluntaryActiveCount, voluntaryTotalCount }: Props) => {
  const { t } = useTranslation();
  const totalActive = mandatoryCount + voluntaryActiveCount;
  const total = mandatoryCount + voluntaryTotalCount;

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} spacing="4" mb="4">
      <CountStat bg="smQuaternarySoft" color="smQuaternary" label={t("mandatory active")}>
        {mandatoryCount}
      </CountStat>
      <CountStat bg="smSecondarySoft" color="smSecondary" label={t("voluntary active")}>
        {voluntaryActiveCount} / {voluntaryTotalCount}
      </CountStat>
      <CountStat bg="smPrimarySofter" color="smPrimary" label={t("total active")}>
        {totalActive} / {total}
      </CountStat>
    </SimpleGrid>
  );
};

const LABEL_BELOW_NUMBER = { "& dl": { display: "flex", flexDirection: "column-reverse" } };

const CountStat = ({ bg, color, label, children }: { bg: string; color: string; label: string; children: ReactNode }) => (
  <Box borderWidth="1px" borderRadius="lg" borderColor="smBorder" p="4" bg={bg}>
    <Stat sx={LABEL_BELOW_NUMBER}>
      <StatLabel fontSize="xs" color="smMuted">
        {label}
      </StatLabel>
      <StatNumber fontSize="xl" color={color}>
        {children}
      </StatNumber>
    </Stat>
  </Box>
);
